const STORAGE_KEY_SUFFIX = 'dateSortPreference';

export const DATE_SORT_OPTIONS = {
  ORDER_DATE: 'order_date',
  UPDATED_IN_GP: 'updated_in_gp'
};

export const getDateSortStorageKey = (userInfo) => {
  if (!userInfo || !userInfo.current_tenant || !userInfo.name) {
    return STORAGE_KEY_SUFFIX;
  }
  return `${userInfo.current_tenant}-${userInfo.name}-${STORAGE_KEY_SUFFIX}`;
};

export const saveDateSortPreference = (userInfo, value) => {
  try {
    const storageKey = getDateSortStorageKey(userInfo);
    localStorage.setItem(storageKey, value);
    return true;
  } catch (error) {
    console.error('Error saving date sort preference:', error);
    return false;
  }
};

export const loadDateSortPreference = (userInfo) => {
  try {
    const storageKey = getDateSortStorageKey(userInfo);
    const stored = localStorage.getItem(storageKey);
    if (stored && Object.values(DATE_SORT_OPTIONS).includes(stored)) {
      return stored;
    }
    return DATE_SORT_OPTIONS.UPDATED_IN_GP;
  } catch (error) {
    console.error('Error loading date sort preference:', error);
    return DATE_SORT_OPTIONS.UPDATED_IN_GP;
  }
};

